import { EVENT_TYPES } from "nemuru-components";

export const constructProgressEvent = (moduleId, relativeScreenPath) => {
  const screenPath = `${moduleId}.${relativeScreenPath}`;
  return {
    name: screenPath,
    type: EVENT_TYPES.progress,
    payload: {
      module: moduleId,
      screenPath: screenPath,
    },
  };
};
